import * as React from "react";
import PriorAuthorizationStepper from "@app/preBill/components/priorAuthorizationStepper";

const PriorAuthorizationPage: React.FC = () => {
  return <PriorAuthorizationStepper />;
};

export default PriorAuthorizationPage;
